module.exports = __webpack_public_path__ + "img/background-study-assessor@2x.e0dbbbfd.jpg";